<template>
	<div class="">
		<div class="flex w-full justify-center">
			<div class="w-full max-w-8xl">
				<div class="flex w-full justify-center md:justify-center">
					<Mango
						:collection="birthKits ? 'birthKits' : 'products'"
						:id="null"
						v-slot="{ data: products, loading, totalResults }"
						:query="{ ...query, search: mangoSearch, sort }"
						:verbose="true"
					>
						<Spinner v-if="loading" />
						<div v-else-if="totalResults === undefined" class="text-center py-8">
							<div class="text-ihh-midnight-gray text-lg font-medium mb-2">No items found</div>
							<div class="text-ihh-slate-gray">Try adjusting your search or filter parameters</div>
						</div>
						<div v-else class="grid grid-cols-2 sm:grid-cols-3 md2:grid-cols-4 gap-x-3 w-full min-w-fit md:min-w-0">
							<Product v-for="p in products" :product="p" :key="p.id" />
						</div>

						<div class="mb-1 mt-12 flex justify-center items-end">
							<button class="pr-2" v-if="query.page > 3" @click="query.page = 0">...</button>
							<button
								@click="query.page = n - 1"
								v-for="n in Array.from({ length: Math.ceil(totalResults / 24) }, (_, i) => i + 1)"
								:key="n"
								:class="[
									'flex justify-center items-center text-sm text-ihh-midnight-gray mx-2.5 font-semibold w-3.5 h-3.5 p-3.5 rounded-md cursor-pointer',
									{
										'bg-ihh-check ring ring-ihh-check ring-offset-4': query.page + 1 === n,
										'bg-ihh-light-lavendar text-ihh-midnight-gray/70': query.page + 1 !== n,
										hidden: n > query.page + 4 || n < query.page - 2,
									},
								]"
							>
								{{ n }}
							</button>
							<button class="pl-2" v-if="Math.ceil(totalResults / 24) > query.page + 4" @click="query.page = Math.ceil(totalResults / 24) - 1">...</button>
						</div>
					</Mango>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Stars from '../../partials/stars.vue'
import Product from '../../products/product.vue'

export default {
	components: { Stars, Product },
	props: {
		algoliaFilters: {
			type: String,
			default: null,
		},
		mangoSearch: {
			type: Object,
			default: () => ({}),
		},
		sort: {
			type: String,
			default: 'Best Selling',
		},
		birthKits: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			query: {
				limit: 24,
				page: 0,
				useAggregation: true, // Use the new aggregation endpoint
				fields: [
					'id',
					'name',
					'bcId',
					'price',
					'image',
					'images',
					'rating',
					'reviews',
					'reviewsCount',
					'variants',
					'outOfStock',
					'currentPrice',
					'customUrl',
					'wasPrice',
					'inventoryTracking',
					'inventoryLevel',
					'trackedInventoryLevel',
					'relatedProducts',
					'availability',
					'isVisible',
					'isPriceHidden',
					'priceHiddenLabel',
					'categories',
					'customFields',
				],
			},
		}
	},
	watch: {
		$route: {
			handler() {
				this.$forceUpdate()
			},
		},
		mangoSearch: {
			handler() {
				this.query.page = 0
				this.$forceUpdate()
			},
			deep: true,
		},
		sort() {
			this.query.page = 0
		},
	},
}
</script>
